import { CodeEditorSegmegment } from "@/api/dto/CodeEditor";
import { AutoTenderType, TenderPriority, CreateReviewRequest, PurchaseLimit, UpdateReviewRequest } from "@/api/dto/Review";
import { PurchaseType } from '@/api/dto/PurchaseType';
import { Skill } from "@/api/dto/Skill";
import moment from "moment";

export const OPTION_1_DAY = 0;
export const OPTION_3_DAY = 1;
export const OPTION_1_WEEK = 2;
export const OPTION_1_MONTH = 3;
export const OPTION_UNLIMITED = 4;

/**
 * 掲載期限のoption値
 */
export type PublishedOption =
  | typeof OPTION_1_DAY
  | typeof OPTION_3_DAY
  | typeof OPTION_1_WEEK
  | typeof OPTION_1_MONTH
  | typeof OPTION_UNLIMITED;

// view のレビューフォーム型
export interface ReviewForm {
  dealId: string | null;
  dealStatus: string;
  language: string;
  title: string;
  purchaseOverview: string;
  codeEditor: CodeEditorSegmegment[];
  purchaseType: PurchaseType;
  amount: number;
  limitCount?: number;
  /**
   * format: YYYY/MM/DD HH:mm:ss
   */
  publishedPeriod: string;
  selectPublishedPeriod: PublishedOption;
  autoTenderType?: AutoTenderType;
  tenderPriority?: TenderPriority;
  tags: string;
  orderSkills: Skill[] | null;
  createDate: Date | string;
  viewPermission: string;
  isUseCoupon: boolean;
}

// レビューフォームからレビュー作成リクエストに変換
export const toCreateReviewRequestFromReviewForm = (
  res: ReviewForm
): CreateReviewRequest => {
  return {
    purchaseType: res.purchaseType,
    title: res.title,
    purchaseOverview: res.purchaseOverview,
    language: res.language,
    tags: res.tags,
    amount: res.amount,
    publishedPeriod: moment(res.publishedPeriod, 'YYYY/MM/DD HH:mm:ss').toISOString(),
    orderSkills: res.orderSkills,
    codeEditor: res.codeEditor,
    purchaseLimit: (!!res.limitCount ? '1' : '2') as PurchaseLimit, // 上限人数=0 の場合は「2(上限なし)」を指定
    limitCount: res.limitCount,
    autoTenderType: res.autoTenderType,
    tenderPriority: res.tenderPriority,
    viewPermission: res.viewPermission,
    isUseCoupon: res.isUseCoupon,
  };
};

// レビューフォームからレビュー更新リクエストに変換
export const toUpdateReviewRequestFromReviewForm = (
  res: ReviewForm
): UpdateReviewRequest => {
  return {
    purchaseType: res.purchaseType,
    title: res.title,
    purchaseOverview: res.purchaseOverview,
    language: res.language,
    tags: res.tags,
    amount: res.amount,
    publishedPeriod: moment(res.publishedPeriod, 'YYYY/MM/DD HH:mm:ss').toISOString(),
    orderSkills: res.orderSkills,
    codeEditor: res.codeEditor,
    purchaseLimit: (!!res.limitCount ? '1' : '2') as PurchaseLimit, // 上限人数=0 の場合は「2(上限なし)」を指定
    limitCount: res.limitCount,
    autoTenderType: res.autoTenderType,
    tenderPriority: res.tenderPriority,
    viewPermission: res.viewPermission,
    isUseCoupon: res.isUseCoupon,
  };
};
